<template>
    <modal :id="utils.randomId({prefix: 'modal'})"
           :show="true"
           size="xl"
           @click.stop.prevent
           @close="hideModal()">

        <template #title>
            <div v-html="title"></div>
        </template>

        <template v-if="modal.is_ready">

            <p v-if="description" v-html="description"></p>

            <div class="form-group">
                <input type="text" class="form-control" v-model="modal.search" placeholder="Search...">
            </div>

            <div class="row">
                <div class="col-sm-4 mb-3" v-for="podcast in filtered_podcasts" :key="podcast.id">
                    <podcast-card :podcast="podcast"
                                  :actions="modal.actions"
                                  :open-in-modal="true"/>
                </div>
            </div>

            <div v-if="!filtered_podcasts.length">
                <p class="text-danger">Sorry, nothing found. Try some other keywords to search.</p>
            </div>


        </template>
        <template v-else>
            Loading...
        </template>

        <template #footer>
            <!--            <button v-if="editable"-->
            <!--                    type="button"-->
            <!--                    @click.prevent.stop="remove()"-->
            <!--                    class="btn btn-danger mr-auto">Remove</button>-->
        </template>

    </modal>
</template>

<script>

import utils from "@/mixins/utils";
import uploads from "@/mixins/uploads";
import Modal from "@/Components/Common/Modal";
import API from "@/API";
import PodcastCard from "@/Components/Podcast/PodcastCard";
export default {
    name: "PodcastBrowserModal",
    components: {Modal, PodcastCard},
    mixins: [utils, uploads],

    emits: ['selected', 'close'],

    props: {
        title: {
            type: String,
            default: 'Select a DFC Podcast'
        },

        description: {
            type: String,
            default: 'Choose a podcast to hear from community members and their perspectives regarding a specific issue that you want to learn more about and solve.'
        }
    },

    data(){
        return {

            modal: {
                is_ready: false,
                search: '',
                podcasts: [],
                actions: {
                    select: {
                        class: 'btn-light',
                        title: 'Select',
                        action: (podcast) => this.selectPodcast(podcast),
                    }
                }
            },
        };
    },


    computed: {
        filtered_podcasts(){
            if( !this.modal.search.length ) return this.modal.podcasts;
            const regex = new RegExp(this.modal.search, 'gi');
            return this.modal.podcasts.filter(p => regex.test(p.name) || regex.test(p.description));
        },
    },

    methods: {

        selectPodcast(podcast){
            this.$emit('selected', podcast);
            this.hideModal();
        },

        async showModal(){
            this.modal.search = '';

            if( !this.modal.is_ready ){
                this.modal.podcasts = await API.podcasts.bulk();
            }

            this.modal.is_ready = true;
        },

        hideModal(){
            this.$emit('close');
        },

    },

    async mounted() {
        await this.showModal();
    }

}
</script>

<style scoped>

</style>
